
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisHeadinglineIec as ObiAisHeadinglineIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-headingline-iec.js';
 
 
 

 
 export const ObiAisHeadinglineIec = createComponent({
   react: React,
   tagName: 'obi-ais-headingline-iec',
   elementClass: ObiAisHeadinglineIecElement,
   events: {
     
   }
  });
 
 